import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rentenversicherung"
export default class extends Controller {
	static targets = ["select", "sozialversicherungspflichtig", "rentenleistung"]

	connect() {
		this.updateLeistungsart()
	}

	updateLeistungsart() {
		if (this.selectTarget.value == "kapitalauszahlung") {
			if (this.hasSozialversicherungspflichtigTarget) this.sozialversicherungspflichtigTarget.classList.remove("hidden")
			if (this.hasRentenleistungTarget) this.rentenleistungTarget.classList.add("hidden")
		} else {
			if (this.hasSozialversicherungspflichtigTarget) this.sozialversicherungspflichtigTarget.classList.add("hidden")
			if (this.hasRentenleistungTarget) this.rentenleistungTarget.classList.remove("hidden")
		}
	}
}
